import { logEvent } from "@/service/logs/log";
import { createPath } from "@/service/routing/routing";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { EbookCard } from "@/components/ebook/ebook-card";

export const Icd10EbookCard = ({
  ebook,
  code,
}: {
  ebook: EbookPreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);

  return (
    <EbookCard
      ebook={ebook}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath("ebook.show", {
            slug: ebook.slug,
          }),
          resource_type: "e-book",
        });
      }}
    />
  );
};
